import React, { Component, Fragment } from "react";
import StandAlone from "./StandAlone";
import Header from "../Components/Header";
import NavBar from "./../Components/navbar";
import SanadNavBar from "../Components/sanadnavbar";
import settings from "../helpers/Settings";
let { apiToken } = settings;

class DRGCalculater extends Component {
  componentDidMount = () => {
    const { history } = this.props;
    if (!apiToken) {
      history.push(`/Sanad/loginAsEmployee`, {
        errorMsg: "You need to sign in or sign up",
      });
    }
  };

  render() {
    return (
      <Fragment>
        <NavBar />
        <Header
          name={localStorage.getItem("SanadName")}
          usertype="employee"
          history={this.props.history}
        />
        <SanadNavBar selected="1" />
        <StandAlone />
      </Fragment>
    );
  }
}

export default DRGCalculater;
